import AdminsPage from './list/AdminsPage.vue';

export default [
  {
    path: '/admins',
    name: 'admins',
    component: AdminsPage,
    meta: {
      title: 'Administrateurs',
      requiresAuth: true
    }
  }
];
